import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';
import { EmptyState, FormField, StatusPill } from '../../../components/app';
import { PayersDialogProps } from '../types';

export function PayersDialog({
  isOpen,
  onOpenChange,
  payers,
  newPayerName,
  onNewPayerNameChange,
  onAddPayer,
  onDeletePayer,
}: PayersDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0">
        <DialogHeader bordered>
          <DialogTitle>Плательщики</DialogTitle>
          <DialogDescription>
            Кто оплатил Расход: Основатель (растёт Долг перед основателем) или Счёт компании (уменьшается Касса).
          </DialogDescription>
        </DialogHeader>
        <DialogBody>
          <div className="flex items-end gap-2">
            <FormField label="Новый плательщик" className="flex-1">
              <Input
                value={newPayerName}
                onChange={(e) => onNewPayerNameChange(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') onAddPayer();
                }}
                placeholder="Имя плательщика"
              />
            </FormField>
            <Button onClick={onAddPayer} size="icon" aria-label="Добавить плательщика" className="shrink-0">
              <Plus />
            </Button>
          </div>

          {payers.length === 0 ? (
            <EmptyState title="Пока нет плательщиков" className="py-6" />
          ) : (
            <ul aria-label="Плательщики" className="m-0 flex max-h-72 list-none flex-col gap-2 overflow-y-auto p-0">
              {payers.map((payer) => (
                <li
                  key={payer.id}
                  className="flex min-h-11 items-center justify-between gap-2 rounded-xl border border-border-soft bg-surface-alt py-1 pl-3 pr-1"
                >
                  <span className="font-semibold">{payer.name}</span>
                  {payer.is_company ? (
                    <StatusPill size="sm" tone="info" className="mr-2">
                      Счёт компании
                    </StatusPill>
                  ) : (
                    <Button
                      variant="ghost"
                      size="icon-sm"
                      onClick={() => onDeletePayer(payer.id)}
                      aria-label={`Удалить плательщика ${payer.name}`}
                    >
                      <Trash2 className="text-neg" />
                    </Button>
                  )}
                </li>
              ))}
            </ul>
          )}
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
